import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'any' })

export class CastToAnyPipe implements PipeTransform {
  transform(value: unknown): any {
    return value as any;
  }
}
